module.exports = __webpack_public_path__ + "lang/en.json";


//////////////////
// WEBPACK FOOTER
// ./lang/en.json
// module id = 115
// module chunks = 3